import {Product} from "@/enum/Product";
import {ProgramPaths} from "@/enum/ProgramPaths";

/**
 * DEV-2113 — ürünlerin ekranda görünen adı, rengi, simgesi ve giriş yolu.
 *
 * Lisans ekranı ve lisans uyarısı ürünü aynı adla ve aynı renkle göstersin diye
 * tek yerde durur. Renkler tema dosyasındaki (plugins/theme.js) ana renklerdir;
 * teması olmayan ürünler nötr gri alır.
 */
export interface UrunBilgisi {
    urun: Product;
    ad: string;
    yol: ProgramPaths;
    renk: string;
    simge: string;
}

const NOTR_GRI = "#5F6D7E";

export const URUN_KATALOGU: UrunBilgisi[] = [
    {urun: Product.OFISPRO, ad: "OfisPro", yol: ProgramPaths.ofispro, renk: "#9D7AE8", simge: require("@/assets/ofisproIcon.svg")},
    {urun: Product.ICRAPROWEB, ad: "İcraPro", yol: ProgramPaths.icrapro, renk: "#5BA3E7", simge: require("@/assets/icraproNewIcon.svg")},
    {urun: Product.EICRAPRO, ad: "e-İcraPro", yol: ProgramPaths.eicrapro, renk: "#FF9500", simge: require("@/assets/eicraproIcon.svg")},
    {urun: Product.ARABULUCUPRO, ad: "ArabulucuPro", yol: ProgramPaths.arabulucupro, renk: NOTR_GRI, simge: require("@/assets/arabulucuproicon.svg")},
    {urun: Product.DAVAPROWEB, ad: "DavaPro", yol: ProgramPaths.davapro, renk: NOTR_GRI, simge: require("@/assets/davaprowebicon.svg")},
];

export function urunBilgisi(urun: number | null | undefined): UrunBilgisi | null {
    if (urun === null || urun === undefined) return null;
    return URUN_KATALOGU.find((u) => u.urun === Number(urun)) ?? null;
}

/** Lisans ekranı sorgusundaki ürün anahtarı ("/icrapro" → "icrapro"). */
export function urunAnahtari(bilgi: UrunBilgisi): string {
    return bilgi.yol.replace(/^\//, "");
}
